import { useEffect } from "react";

function NoOverflowWrapper({ children }) {
  useEffect(() => {
    document.body.style.overflowY = "hidden";
    document.body.style.overflowX = "hidden";

    return () => {
      document.body.style.overflowY = "";
      document.body.style.overflowX = "";
    };
  }, []);

  return <div className="w-full">{children} </div>;
}

export default NoOverflowWrapper;
